import * as React from 'react'
import Page from '../../components/page/Page'
import {createStyles, Grid, Tab, Tabs, Theme, withStyles, WithStyles, withTheme, WithTheme} from "@material-ui/core";
import {RouteComponentProps} from "@reach/router";
import MarginRow from "../../components/page/MarginRow";
import {inject, observer} from "mobx-react";
import UserStore from "../../stores/UserStore";
import AccountStore, {AccountStoreConstants} from "../../stores/AccountStore";
import Account from "../../model/Account"
import {observable, when} from "mobx";
import User from "../../model/User";
import Progress from "../../components/Progress";
import ControlTower, {Routes} from "../../components/ControlTower";
import AccountInfo from "./AccountInfo";
import AccountClasses from "./AccountClasses";
import AccountUsers from "./AccountUsers";
import TitleBar from "../../components/TitleBar";
import NavigationBar from "../../components/NavigationBar";
import AccountBilling from "./AccountBilling";
import AccountComplianceReport from "./AccountComplianceReport";

const styles = (theme: Theme) => createStyles({
  root: {
    flexGrow: 1,
    width: "100%",
    justifyContent: 'top',
    alignItems: 'center',
    overflow: "hidden"
  },
  navigation: {
  },
  content: {
    overflow: "hidden"
  },
  navigationBar: {
    display: "flex",
    flex: "none",
    flexDirection: "row",
    height: 30,
    width: "100%",
    maxWidth: 960,
    paddingRight: theme.spacing(1)
  },
  tabs: {

  },
  tab: {
    [theme.breakpoints.down('xs')]: {
      fontSize: 15,
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: 15,
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: 15,
    },
    fontWeight: 800
  },
  hiddenTab: {
    display: "none"
  }
})

export enum AccountTabNames {
  info = "info",
  classes = "classes",
  students = "students",
  reports = "reports"
}

interface IAccountPageProps {
  userStore?: UserStore
  accountStore?: AccountStore
  progress?: Progress
  accountId?: string
  tab?: string
}

@inject("userStore", "accountStore", "progress")
@observer
class AccountPage extends React.Component<WithStyles<typeof styles> & RouteComponentProps & IAccountPageProps & WithTheme> {

  tabNames: string[] = ["info", "classes", "billing", "people", "compliance"]

  @observable account?: Account
  @observable user?: User
  @observable isLoading = true

  componentDidMount () {
    const { progress, accountId } = this.props

    this.isLoading = true
    progress!.show("AccountPage")
    const { userStore, accountStore} = this.props
    when(
      () => !userStore!.isLoading && accountId !== undefined,
      async () => {
        this.account = await accountStore!.loadAccount(accountId!)
        this.user = userStore!.user
        this.isLoading = false
        progress!.hide("AccountPage")
      }
    )
  }

  handleChange = (event: any, value: any) => {
    // Navigate to tab to allow a direct url to each tab
     ControlTower.route(`${Routes.account}/${this.props.accountId}/${value}`)
  }

  render() {
    const { classes, userStore, accountStore } = this.props

    if (!this.account) {
      return null
    }

    const title = (this.isLoading ||
                  (this.user && this.user.isStudent && this.account.id === AccountStoreConstants.INDIVIDUAL_ACCOUNT_ID)) ?
                    "Account" : this.account!.name

    const tabName = (this.props.tab !== undefined) ? this.props.tab : this.tabNames[0]
    let tabValue = this.tabNames.findIndex(name => tabName === name)
    if (tabValue < 0) {
      tabValue = 0
    }

    const isAdmin = userStore!.isAdmin
    const isOwner = userStore!.isOwner
    const isIndividual = accountStore!.isIndividual

    return (
      <Page title={title}>
        <MarginRow>
          <div className={ classes.root}>
            <Grid container className={classes.navigation}>
              { isAdmin &&
                <div className={classes.navigationBar}>
                  <NavigationBar title="Accounts" onBack={this.onBack}/>
                </div>
              }
              <TitleBar title={title}>
              </TitleBar>
              <Tabs
                value={tabName}
                onChange={this.handleChange}
                variant="fullWidth"
                indicatorColor="secondary"
                textColor="secondary"
                className={ classes.tabs }
              >
                <Tab className={classes.tab} value="info" label="Information"/>
                <Tab className={classes.tab} value="classes" label="Classes"/>
                <Tab className={classes.tab} value="billing" label="Billing" />
                {((isOwner && !isIndividual) || isAdmin) &&
                  <Tab className={classes.tab} value="people" label="People" />
                }
                {((isOwner && !isIndividual) || isAdmin) &&
                  <Tab className={classes.tab} value="compliance" label="Compliance" />
                }
              </Tabs>
            </Grid>
            <Grid container className={classes.content}>
              {tabName === "info" && <AccountInfo />}
              {tabName === "classes" && <AccountClasses />}
              {tabName === "billing" && <AccountBilling />}
              {tabName === "people" && ((isOwner && !isIndividual) || isAdmin) && <AccountUsers />}
              {tabName === "compliance" && ((isOwner && !isIndividual) || isAdmin) &&<AccountComplianceReport />}
            </Grid>
          </div>
        </MarginRow>
      </Page>
    )
  }

  onBack = () => {
    ControlTower.route(Routes.accounts)
  }

  onAddClass = () => {
    // TODO
  }

}

export default withTheme((withStyles(styles)(AccountPage)))